.fz{border:1px solid #ddd;}